const i = "image", e = "image__img", a = "image__container", g = "image__description", m = "image__caption", t = "image__copyright", _ = {
  image: i,
  image__img: e,
  image__container: a,
  "image--fullscreen": "image--fullscreen",
  "image--bleed": "image--bleed",
  "image--original": "image--original",
  "image--contain": "image--contain",
  "image--fill-container": "image--fill-container",
  "image--top": "image--top",
  "image--center": "image--center",
  "image--bottom": "image--bottom",
  "image--full-height": "image--full-height",
  image__description: g,
  image__caption: m,
  image__copyright: t,
  "image__img--ratio-hd": "image__img--ratio-hd",
  "image__img--ratio-wide": "image__img--ratio-wide",
  "image__img--ratio-square": "image__img--ratio-square",
  "image__img--ratio-vertical": "image__img--ratio-vertical",
  "image__img--ratio-normal": "image__img--ratio-normal",
  "image__img--ratio-sixtofive": "image__img--ratio-sixtofive",
  "image__img--ratio-fivetofour": "image__img--ratio-fivetofour",
  "image__img--ratio-ninetosixteen": "image__img--ratio-ninetosixteen"
};
export {
  _ as default,
  i as image,
  m as image__caption,
  a as image__container,
  t as image__copyright,
  g as image__description,
  e as image__img
};
